import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAJa6LODBvS0rzqY1NAZP3gvAl47qAmU7c",
  authDomain: "getthelp.firebaseapp.com",
  projectId: "getthelp",
  storageBucket: "getthelp.firebasestorage.app",
  messagingSenderId: "491150123084",
  appId: "1:491150123084:web:e79cc5d5c943ac9ce454e9",
  measurementId: "G-TTJS8C91M5",

  // ⚠️ חובה ל-Realtime DB. צור Database ב-Firebase Console
  //    (Build → Realtime Database → Create) והדבק כאן את ה-URL המדויק.
  databaseURL: "https://getthelp-default-rtdb.firebaseio.com",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const storage = getStorage(app);

export default app;
